let systemClockOffset = 0;

// Given a client date return a corrected date so that it's aligned to server time (in case server & client times differ significantly)
export const getSkewCorrectedDate = (when: Date): Date =>
  new Date(when.getTime() + systemClockOffset);

/* eslint-disable @typescript-eslint/naming-convention -- just for tests */
/* eslint-disable no-underscore-dangle -- just for tests */
// For tests only! Do not use these functions outside of the unit tests
export const _getCurrentSystemClockOffsetInSeconds = () => systemClockOffset / 1_000;
export const _setCurrentSystemClockOffsetInSeconds = (newOffset: number) => {
  systemClockOffset = newOffset;
};
/* eslint-enable no-underscore-dangle -- just for tests */
/* eslint-enable @typescript-eslint/naming-convention -- just for tests */

export const isClockSkewed = (serverTime: Date, clientTime: Date): boolean =>
  Math.abs(getSkewCorrectedDate(clientTime).getTime() - serverTime.getTime()) >= 300_000;

export const updateSystemClockOffset = (serverTime: Date, clientTime: Date) => {
  systemClockOffset = serverTime.getTime() - clientTime.getTime();
};

// Given some server response, try to detect if there is a significant difference
// between the client & server time. If there is the difference will be stored globally.
export const maybeUpdateClockOffset = (serverTime: Date): boolean => {
  const clientTime = new Date();

  if (!Number.isNaN(serverTime.getTime()) && isClockSkewed(serverTime, clientTime)) {
    updateSystemClockOffset(serverTime, clientTime);
    return true;
  }

  return false;
};
